import { VoiceLanguage, convertFileIdToDownloadURI } from './util'

export const enVoiceFileIds = {
  TrustyReceived: 'TrustyReceived.mp3',
  1: '1.mp3',
  2: '2.mp3',
  3: '3.mp3',
  4: '4.mp3',
  5: '5.mp3',
  6: '6.mp3',
  7: '7.mp3',
  8: '8.mp3',
  9: '9.mp3',
  10: '10.mp3',
  11: '11.mp3',
  12: '12.mp3',
  13: '13.mp3',
  14: '14.mp3',
  15: '15.mp3',
  16: '16.mp3',
  17: '17.mp3',
  18: '18.mp3',
  19: '19.mp3',
  20: '20.mp3',
  30: '30.mp3',
  40: '40.mp3',
  50: '50.mp3',
  60: '60.mp3',
  70: '70.mp3',
  80: '80.mp3',
  90: '90.mp3',
  100: '100.mp3',
  1000: 'thousand.mp3',
  1000000: 'million.mp3',
  1000000000: 'billion.mp3'
}

export const enVoiceMap = convertFileIdToDownloadURI(
  VoiceLanguage.English,
  enVoiceFileIds
)

export function preloadEnVoice() {
  Object.values(enVoiceMap).forEach(url => {
    const audio = new Audio()
    audio.src = url
    audio.preload = 'metadata'
  })
}

function enConvertNumberToSpeechNumber(num) {
  let data = []
  // billion
  const b = 1000000000
  if (num >= b) {
    let n = Math.floor(num / b)
    data = data.concat(enConvertNumberToSpeechNumber(n))
    data.push(b)
    num = num % b
  }
  const m = 1000000
  if (num >= m) {
    let n = Math.floor(num / m)
    data = data.concat(enConvertNumberToSpeechNumber(n))
    data.push(m)
    num = num % m
  }
  const t = 1000
  if (num >= t) {
    let n = Math.floor(num / t)
    data = data.concat(enConvertNumberToSpeechNumber(n))
    data.push(t)
    num = num % t
  }
  const h = 100
  if (num >= h) {
    let n = Math.floor(num / h)
    data = data.concat(enConvertNumberToSpeechNumber(n))
    data.push(h)
    num = num % 100
  }
  if (num > 20) {
    let n = Math.floor(num / 10) * 10
    data = data.concat(n)
    num = num % 10
  }
  if (num > 0) {
    data.push(num)
  }

  return data
}

export function enConvertNumberToSpeechVoice(num) {
  let voiceList = [enVoiceMap.TrustyReceived].concat(
    enConvertNumberToSpeechNumber(num).map(i => {
      return enVoiceMap[i]
    })
  )
  return voiceList
}
